export default __webpack_public_path__ + "static/media/02.a3ad0a60.jpeg";